import {
  PROFILE_CONNECTING,
  PROFILE_DATA
} from 'store/types';

const INITIALSTATE = {
  timestamp: null,
  loading: null,
  profile: {},
  currentUser_with_additionals: {}
};

export default function (state = INITIALSTATE, action) {
  switch (action.type) {
    case PROFILE_CONNECTING:
      return {
        ...Object.assign(state, {
          timestamp: new Date(),
          loading: true,
        })
      };
    case PROFILE_DATA:
      return {
        ...Object.assign(state, {
          timestamp: new Date(),
          loading: false,
          ...action.payload
        })
      };
    default:
      return state;
  }
};
